import { mergeTemplate } from './base-template';

export const fotografieTemplate = mergeTemplate({
  name: 'Fotografie',
  icon: '📷',
  settings: {
    primaryColor: '#171717',
    accentColor: '#f5f5f5',
    darkMode: true,
    fontStack: 'instrument',
    stylePreset: 'editorial',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Fotografie-Pakete',
      heroSubtitle: 'Professionelle Bilder für jeden Anlass',
      packages: [
        { name: 'Portrait', price: 'ab CHF 350', description: 'Persönliche Portrait-Session', features: '1h Shooting, 2 Locations, 10 bearbeitete Bilder, Online-Galerie', highlighted: false },
        { name: 'Business', price: 'ab CHF 890', description: 'Corporate Fotografie und Headshots', features: 'Team-Shooting, Headshots, Arbeitsplatz-Bilder, 25 bearbeitete Bilder, Nutzungsrechte', highlighted: true },
        { name: 'Event', price: "ab CHF 1'500", description: 'Professionelle Eventdokumentation', features: 'Ganztags-Begleitung, 100+ bearbeitete Bilder, Online-Galerie, Druckdateien', highlighted: false },
      ],
      ctaTitle: 'Bilder sagen mehr als Worte',
      ctaText: 'Lassen Sie uns über Ihr Projekt sprechen — ich freue mich auf Ihre Ideen.',
      ctaButtonText: 'Anfrage senden',
    },
    pageMethoden: {
      heroTitle: 'Mein Workflow',
      heroSubtitle: 'Vom Vorgespräch bis zum fertigen Bild',
      introText: 'Gute Fotografie braucht Vorbereitung, Vertrauen und ein Auge fürs Detail. So arbeite ich mit meinen Kunden.',
      steps: [
        { title: 'Vorgespräch', description: 'Ihre Vision, Ihre Wünsche, meine Empfehlungen — alles in einem Gespräch' },
        { title: 'Shooting', description: 'Entspannte Atmosphäre, professionelle Ausrüstung, kreative Regie' },
        { title: 'Bearbeitung', description: 'Sorgfältige Auswahl und professionelles Editing' },
        { title: 'Lieferung', description: 'Online-Galerie, Hochauflösende Downloads, optional Prints' },
      ],
      tools: [
        { name: 'Profi-Ausrüstung', description: 'Canon/Sony Vollformat, Studioblitz, Reflektoren' },
        { name: 'Adobe Lightroom & Photoshop', description: 'Professionelle Bildbearbeitung' },
        { name: 'Online-Galerie', description: 'Bequeme Bildauswahl und Download für Kunden' },
      ],
      philosophyTitle: 'Meine Fotografie-Philosophie',
      philosophyText: 'Ich fotografiere keine Bilder — ich erzähle Geschichten. Authentisch, ehrlich und mit Liebe zum Moment.',
    },
    pageUeberMich: {
      heroTitle: 'Über mich',
      heroSubtitle: 'Fotograf aus Leidenschaft',
      introText: 'Seit über 10 Jahren halte ich Momente fest — für Menschen, Unternehmen und besondere Anlässe.',
      imageUrl: '',
      timeline: [
        { year: '2013', text: 'Start als freischaffender Fotograf' },
        { year: '2017', text: 'Eröffnung des eigenen Studios' },
        { year: '2022', text: 'Swiss Press Photo Nominierung' },
      ],
      values: [
        { title: 'Authentizität', description: 'Echte Momente statt gestellter Posen' },
        { title: 'Qualität', description: 'Jedes Bild wird sorgfältig bearbeitet und geprüft' },
        { title: 'Persönlichkeit', description: 'Ich fotografiere Menschen, nicht Objekte' },
      ],
      certifications: 'SBF-Mitglied, Adobe Certified Expert',
    },
  },
  components: {
    header: {
      companyName: 'Foto Muster',
      logoText: 'FM',
      navItems: ['Portfolio', 'Arbeitsweise', 'Studio', 'Kontakt'],
      ctaText: 'Anfrage',
    },
    hero: {
      title: 'Bilder, die erzählen.',
      subtitle: 'Fotografie für Unternehmen und Persönlichkeiten.',
      primaryBtn: 'Projekt anfragen',
      secondaryBtn: 'Portfolio',
    },
    trust: {
      items: [
        { value: 'Natürlich', label: 'Stil' },
        { value: 'Professionell', label: 'Workflow' },
        { value: 'Schnell', label: 'Lieferung' },
        { value: 'Authentisch', label: 'Bilder' },
      ],
    },
    services: {
      title: 'Leistungen',
      subtitle: 'Für Business und Private.',
      items: [
        {
          icon: '👔',
          title: 'Business Portraits',
          text: 'Professionelle Bilder für Web, LinkedIn, Presse.',
        },
        {
          icon: '🏢',
          title: 'Unternehmensreportage',
          text: 'Prozesse, Teams, Räume – authentisch dokumentiert.',
        },
        {
          icon: '🎉',
          title: 'Events',
          text: 'Anlässe, Konferenzen, Feiern.',
        },
      ],
    },
    process: {
      title: 'Ablauf',
      subtitle: '',
      steps: [
        {
          num: '1',
          title: 'Briefing',
          text: 'Zweck, Stil, Einsatz der Bilder klären.',
        },
        {
          num: '2',
          title: 'Shooting',
          text: 'Entspannt, effizient, professionell.',
        },
        {
          num: '3',
          title: 'Auswahl',
          text: 'Gemeinsame Bildauswahl online.',
        },
        {
          num: '4',
          title: 'Lieferung',
          text: 'Bearbeitete Bilder in allen gewünschten Formaten.',
        },
      ],
    },
    team: {
      title: 'Das Studio',
      subtitle: 'Kreative Köpfe hinter der Kamera.',
      members: [
        {
          name: 'Lukas Widmer',
          role: 'Fotograf & Gründer',
          image: '',
          bio: 'Spezialisiert auf Business- und Eventfotografie. Seit über 10 Jahren freischaffend in der Schweiz tätig.',
        },
        {
          name: 'Nina Bachmann',
          role: 'Fotografin & Bildbearbeitung',
          image: '',
          bio: 'Fokus auf Portraitfotografie und Retouching. Bringt ein feines Auge für Farben und Stimmungen mit.',
        },
      ],
    },
    testimonials: {
      title: 'Kundenfeedback',
      items: [
        {
          quote: 'Entspanntes Shooting, fantastische Bilder.',
          author: 'Kunde',
          role: 'Geschäftsführer',
        },
        {
          quote: 'Die Teamfotos waren innert einer Woche fertig — alle Mitarbeitenden begeistert.',
          author: 'S. Koller',
          role: 'HR-Leiterin, IT-Unternehmen',
        },
        {
          quote: 'Lukas hat unsere Firmenfeier so eingefangen, dass man die Stimmung auf jedem Bild spürt.',
          author: 'P. Zimmermann',
          role: 'Eventmanagerin, Zürich',
        },
        {
          quote: 'Professionell, unkompliziert und die Ergebnisse sprechen für sich. Absolute Empfehlung.',
          author: 'D. Gerber',
          role: 'Inhaberin, Boutique Bern',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      items: [
        {
          question: 'Wie lange dauert ein Shooting?',
          answer:
            'Je nach Umfang 1-4 Stunden. Wir planen genug Zeit für entspannte Resultate.',
        },
        {
          question: 'Wann erhalte ich die fertigen Bilder?',
          answer:
            'In der Regel innert 5-10 Arbeitstagen nach dem Shooting. Bei dringenden Projekten ist ein Express-Service möglich (Aufpreis ab CHF 150).',
        },
        {
          question: 'Kann ich die Bilder für Social Media und Print verwenden?',
          answer:
            'Ja. Sie erhalten die Nutzungsrechte für alle vereinbarten Zwecke. Die Bilder werden in verschiedenen Formaten (Web, Print, Social Media) geliefert.',
        },
      ],
    },
    cta: {
      title: 'Projekt anfragen',
      subtitle:
        'Schildern Sie Ihr Projekt – ich melde mich mit einem Vorschlag.',
      email: 'foto@example.ch',
    },
    footer: {
      companyName: 'Foto Muster',
      tagline: 'Fotografie in Ihrer Region.',
      email: 'foto@example.ch',
    },
  },
});
